export default __webpack_public_path__ + "static/media/FB dark.09fb6058.svg";